import {Component} from "@/event/calendar/dom/Component.ts";
import {CalendarView} from "@/event/calendar/CalendarModel.ts";

/** Base class for all view bodies */
export class CalendarComponent extends Component {
	protected view: CalendarView;

	constructor(view: CalendarView) {
		super();
		this.view = view;
	}

	/** Set position of calendar to today's date */
	moveToToday(max: boolean = false) {
	}

	moveToDate(date:Date, smooth=true) {
	}

	moveToPrevious(max: boolean = false) {
	}

	moveToNext(max: boolean = false) {
	}

	zoomIn(max = false) {
	}

	zoomOut(max = false) {
	}
}